import { useContext } from 'react';
import { CommerceContext } from './CommerceProvider';

export default function useStateEngine() {
    const { stateMachine } = useContext(CommerceContext);
    return stateMachine;
}
